import { ReactNode } from 'react';
import { Stack } from '@/components/ui/layout';
import { StaggeredList } from './scroll';

export interface AnimatedFormWrapperProps {
  children: ReactNode;
  animation?: 'stagger' | 'none';
  delay?: number;
  staggerDelay?: number;
}

export function AnimatedFormWrapper({
  children,
  animation = 'stagger',
  delay = 0,
  staggerDelay = 100,
}: AnimatedFormWrapperProps) {
  if (animation === 'none') {
    return <Stack gap="md">{children}</Stack>;
  }

  return (
    <StaggeredList
      staggerDelay={staggerDelay}
      initialDelay={delay}
    >
      <Stack gap="md">{children}</Stack>
    </StaggeredList>
  );
}

export default AnimatedFormWrapper;
